export const INSURANCE_DATA_REQUEST = 'INSURANCE_DATA_REQUEST';
export const INSURANCE_DATA_SUCCESS = 'INSURANCE_DATA_SUCCESS';
export const INSURANCE_DATA_FAIL = 'INSURANCE_DATA_FAIL';
